import { ToastrService } from 'ngx-toastr';
import { apiUrl } from './../config/app.config';

import { Usuarios } from '../../models/Usuario/usuarios.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { NavigationMockApi } from 'app/data/mock/common/navigation';
import { Configuracoes } from 'app/models/Configuracoes/configuracoes';
import { Router } from '@angular/router';


@Injectable()
export class AuthService
{
    // Private
    private _authenticated: boolean;

    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        private _httpClient: HttpClient, private _defaultNavigation: NavigationMockApi, private toastr: ToastrService, private router: Router
    )
    {
        // Set the defaults
        this._authenticated = false;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------


    /**
     * Setter and getter for access token
     */
    set accessToken(token: string)
    {
        localStorage.setItem('access_token', token);
    }

    get accessToken(): string
    {
        return localStorage.getItem('access_token');
    }

    setUsuario(usuario: Usuarios){

        localStorage.setItem('usuario', JSON.stringify(usuario));
    }

    setConfiguracoes(configuracoes: Configuracoes){
        localStorage.setItem('configuracoes', JSON.stringify(configuracoes));
    }

    getUsuario(): string
    {
        return localStorage.getItem('usuario');
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Sign in
     *
     * @param credentials
     */
    private usuario: Usuarios = new Usuarios();


    signIn(usuario): Observable<any>
    {
        // Throw error, if the user is already logged in
        if ( this._authenticated )
        {
            return throwError('O usuário está logado.');
        }

        return this._httpClient.post(apiUrl + 'v1/usuario/login', usuario).pipe(
            switchMap((response: any) => {

                // Store the access token in the local storage
                this.accessToken = response.access_token;
                this.setUsuario(response.user);
                this.setConfiguracoes(response.configuracoes);
                localStorage.removeItem('Ação');

                if(response.user.tipo == "Administrador"){
                    this._defaultNavigation.navAdmin();
                }
                else if(response.user.tipo == "Gerente"){
                    this._defaultNavigation.navGerente();
                }
                else if(response.user.tipo == "Vendedor"){
                    this._defaultNavigation.navVendedor();
                }
                else if(response.user.tipo == "Programador"){
                    this._defaultNavigation.navProgramador();
                }
                else if(response.user.tipo == "Apostador"){
                    this._defaultNavigation.navApostador();
                }
                else{
                    this._defaultNavigation.navCliente();
                }

                this._authenticated = true;

                // Return a new observable with the response
                return of(response);
            })
        );
    }

    /**
     * Sign in using the access token
     */
    signInUsingToken(): Observable<any>
    {

        const usuario: Usuarios = JSON.parse(this.getUsuario());
        console.log(this.router.url);

        // Renew token
        return this._httpClient.post(apiUrl + 'v1/usuario/refresh_token', usuario).pipe(
            switchMap((response: any) => {

                // Store the access token in the local storage
                this.accessToken = response.access_token;
                this.setUsuario(response.user);
                this.setConfiguracoes(response.configuracoes);
                localStorage.removeItem('Ação');

                // Set the authenticated flag to true
                this._authenticated = true;

                // Return a new observable with the response
                return of(response);
            }),
            catchError((err: any) => {
                this.toastr.error("Sem Autorização.");
                localStorage.setItem('Ação', 'Saiu');
                return this.signOut();
            })
        );
    }

    /**
     * Sign out
     */
    signOut(): Observable<any>
    {
        // Remove the access token from the local storage
        localStorage.removeItem('access_token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('configuracoes');
        localStorage.removeItem('bilhete');
        // Set the authenticated flag to false
        this._authenticated = false;
        // Return the observable
        return of(true);
    }

    /**
     * Check the authentication status
     */
    check(): Observable<boolean>
    {
        // Check if the user is logged in
        if ( this._authenticated )
        {
            return of(true);
        }

        // Check the access token availability
        if ( !this.accessToken )
        {
            return of(false);
        }

        // Check the access token expire date
        if ( AuthUtils.isTokenExpired(this.accessToken) )
        {
            return of(false);
        }

        // If the access token exists and it didn't expire, sign in using it
        return this.signInUsingToken();
    }
}
